const selectors = {
  classRoomMedia: (state) => state.media.classRoomMedia,
  routinesMedia: (state) => state.media.routinesMedia,
  mediaMain: (state) => state.media.mediaMain,
  pagination: (state) => state.media.pagination,
  currentMedia: (state) => state.media.currentMedia,
  isPhotoTabSelected: (state) => state.media.isPhotoTabSelected,

  loadingMediaStatus: (state) => state.media.loadingMediaStatus,
};

export { selectors };
